function InspectionReducer(state, action) {
  const { field, value } = action.payload;

  switch (action.type) {
    case 'inspection':
      if (field === 'inspectedById') {
        return {
          ...state,
          inspectedBy: value.inspectedBy,
          inspectedById: value.inspectedById,
        };
      }
      return { ...state, [field]: value };

    case 'categoryWiseInspection':
      return {
        ...state,
        ...value,
      };

    case 'partWiseInspection':
      return {
        ...state,
        ...value,
      };

    case 'customTemplateInspection':
      return {
        ...state,
        ...value,
      };

    case 'isEdit':
      return { ...state, ...value };

    case 'isConditionState':
      return { ...state, ...value };

    case 'updateInspection':
      return { ...state, ...value };

    case 'clearInpectionState':
      return {};

    default:
      return state;
  }
}
export default InspectionReducer;
